import React, { Dispatch, SetStateAction } from "react";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';

import ProtectedPage from "../components/ProtectedPage";

function Essay2606(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
   
      
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_PASSWORDS
      );
    
      useMetaTags({
        title: '모두와 작별하기 - Lynkim',
        // description: '모두와 이별하기',
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요">
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'모두와 작별하기'}
                titleEn={'Saying goodbye to everyone'}
                // description={<div>모두와 이별하기</div>}
                category={'essay'}
                date={'2026.05.20.'}
                // thumbnail={image1}
            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>

            <ArticleTextSection 
                title = '모두와 작별하기'
                marginBottom={true}
                marginTop={true}
                description={<div>
                    지금까지 거짓된 마음으로 살아왔다. 잘못을 뉘우치기 위해 모두와 이별하는 것은 나에게 합당한 벌이다. 
                    나를 좋아해주던 사람들이 답답해하겠지. 그리고 점점 생각도 나지 않을 것 같다. 나를 좋아했던 모두가 나에게 실망하고 떠나가길 바란다.
                    모든 사람들이 나에 대해 잊으면 과거의 나는 죽고 사라질거야. 그리고 다시 존중받을 수 있는 때가 오면, 그때 다시 새로운 관계를 쌓아갈 수 있을거야. 
                    세상에서 사라지자. 더이상 아이린은 살아있어서는 안돼. 
                    </div>} />

            
        </div>
        </ProtectedPage>
        </>
      )
  }

export default Essay2606;